export default __webpack_public_path__ + "locales/ja-JP/CreateEditRoomDialog.json?hash=57836c46602b23c62eb512beae14aee2";